import styled from "styled-components"
import constants from "utils/constants"

import IntersectionChecker from "components/containers/common/IntersectionChecker"

export default function ProductDescription({ changeCurrTabByScroll, descriptions }) {
  return (
    <>
      <IntersectionChecker
        options={{ rootMargin: "-65px 0px 0px 0px" }}
        onTopIntersectOut={() => {
          if (changeCurrTabByScroll) {
            changeCurrTabByScroll("product_info")
          }
        }}
      />
      <DescriptionBlock id="product_info">
        {Array.isArray(descriptions) &&
          descriptions.map((desc, index) => (
            <div key={`product-description-index-${index}`}>
              <DescriptionImg
                src={`${constants.imagePath}/commerce/product/description_img/${desc.filename}`}
                alt="product info img"
              />
            </div>
          ))}
      </DescriptionBlock>
      <IntersectionChecker
        options={{ rootMargin: "-150px 0px 0px 0px" }}
        onTopIntersectIn={() => {
          changeCurrTabByScroll("product_info")
        }}
      />
    </>
  )
}

const DescriptionBlock = styled.div`
  margin-bottom: calc(100vw * (26 / 375));
`

const DescriptionImg = styled.img`
  width: 100%;
  object-fit: cover;
`
